import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormDiamond"><Path d="M12 2L2 12L12 22L22 12L12 2Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormDiamond;
